<template>
  <!-- Content -->
  <section id="content" class="content tvapp-cont">
    <!-- Content Body -->
    <div class="content-body">
      <!-- 탭메뉴 -->
      <div class="tab-type1-wrap in-sec">
        <!-- SCREENSHOTS -->
        <div class="view-section view-screenshots" v-if="loadingYn == 'N'">
          <div class="swiper-wrap swiper-screenshots" v-for="item in prodInfo">
            <!-- 상세그룹  -->
            <!--  대체텍스트 형식 : alt="[앱 제목] + Screenshots + [Index]" -->
            <div class="swiper-container">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(screenShot, index) in screenShotList">
                  <a href="javascript:;" :data-src="screenShot.orgFilePath" onclick="zommer.open(this); return $('.zommer-body .zommer-img').attr('tabindex', '-1').focus();"><img :src="screenShot.orgFilePath" :alt="$t('gwa.alt.tvapp.wa_etc_3', { var1 : item.appName, var2 : (index+1) })" /></a>
                </div>
              </div>
            </div>
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
          </div>
        </div>
        <!-- //SCREENSHOTS -->
        <div class="section-body" v-if="loadingYn == 'Y'">
          <div class="loading-wrap">
            <div class="loading"><img src="/img/cmn/loading.png" :alt="$t('gwa.alt.common.wa_etc_1')"></div>
          </div>
        </div>
        <div class="tab-body" v-else>
          <!-- 상세섹션 -->
          <section class="section section-category outline" v-for="item in prodInfo">
            <p class="blind blind-selected dv-pc-only"></p><!-- 선택된탭제목 목차텍스트로 가져오기 -->
            <div class="section-body">
              <!-- 앱상세 전체영역 -->
              <div class="view-app-wrap" :appName="item.appName">
                <!-- 주요정보 -->
                <div class="view-header pc">
                  <div class="tbl-wrap">
                    <p class="thumbnail"><img :src="item.bigIconFile" :alt="$t('gwa.alt.tvapp.wa_etc_1', { var1 : item.appName })" onerror="imageResize.reset(this)" /></p>
                    <div class="tbl-type2">
                      <div class="section-header">
                        <div class="appIcon">
                          <img :src="item.bigIconFile" :alt="$t('gwa.alt.tvapp.wa_etc_1', { var1 : item.appName })" onerror="imageResize.reset(this)" />
                        </div>
                        <div class="inner">
                          <h3 class="tit-h3 tvappTitle"><span role="text">{{ item.appName }} <i v-for="feat in featureList" :class="'ico ico-category'+feat.icoType">{{ getFeatIconText(feat.icoType) }}</i></span></h3>
                        </div>
                      </div>
                      <table>
                        <colgroup>
                          <col width="*">
                          <col width="21%">
                          <col width="23%">
                          <col width="18%">
                          <col width="20%">
                        </colgroup>
                        <caption>
                          <strong>{{ $t("gwa.alt.common.wa_caption_5", { var1 : item.appName }) }}</strong>
                          <p>{{ $t("gwa.alt.common.wa_summary_5_pc") }}</p>
                        </caption>
                        <thead>
                        <tr>
                          <th scope="col">Age</th>
                          <th scope="col">Category</th>
                          <th scope="col">Updated</th>
                          <th scope="col">Version</th>
                          <th scope="col">Size</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                          <td>
                            <p class="tb_ctxt">{{ item.appAge }}</p>
                          </td>
                          <td>
                            <p class="tb_ctxt">{{ item.cat }}</p>
                          </td>
                          <td>
                            <p class="tb_ctxt">{{ item.updateDate }}</p>
                          </td>
                          <td>
                            <p class="tb_ctxt">{{ item.appVer }}</p>
                          </td>
                          <td>
                            <p class="tb_ctxt mb" v-html="fileSizeReplace(item.appFileSize)"></p>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="view-header mob">
                  <div class="tbl-wrap">
                    <p class="thumbnail"><img :src="item.bigIconFile" :alt="$t('gwa.alt.tvapp.wa_etc_1', { var1 : item.appName })" onerror="imageResize.reset(this)" /></p>
                    <div class="tbl-type2">
                      <div class="section-header">
                        <div class="inner">
                          <div class="iconbox">
                            <i v-for="feat in featureList" :class="'ico ico-category'+feat.icoType">{{ getFeatIconText(feat.icoType)}}</i>
                          </div>
                          <h3 class="tit-h3 tvappTitle"><span role="text">{{ item.appName }}</span></h3>
                        </div>
                      </div>
                      <div class="mob-infobox">
                        <p class="mob-infoVersion">Version {{ item.appVer }}</p>
                        <p class="mob-infoTxt">{{ item.updateDate }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="view-table mob">
                    <table>
                      <colgroup>
                        <col width="30%">
                        <col width="40%">
                        <col width="30%">
                      </colgroup>
                      <caption>
                        <strong>{{ $t("gwa.alt.common.wa_caption_5", { var1 : item.appName }) }}</strong>
                        <p>{{ $t("gwa.alt.common.wa_summary_5_mob") }}</p>
                      </caption>
                      <thead>
                      <tr>
                        <th scope="col">Age</th>
                        <th scope="col">Category</th>
                        <th scope="col">Size</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td>
                          <p class="tb_ctxt">{{ item.appAge }}</p>
                        </td>
                        <td>
                          <p class="tb_ctxt">{{ item.cat }}</p>
                        </td>
                        <td>
                          <p class="tb_ctxt mb" v-html="fileSizeReplace(item.appFileSize)"></p>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <!-- //주요정보 -->
                <!-- 상세정보 -->
                <div class="view-body">
                  <div class="tab-wrap">
                    <div class="tab-header">
                      <div class="tab-headerTxtbox">
                        <p class="tab-headerTxt">OVERVIEW</p>
                      </div>
                    </div>
                    <div class="tab-body">
                      <!-- 탭내용1 -->
                      <div id="tabViewCont1" class="tab-content is-active" role="tabpanel" aria-labelledby="tabViewNav1" aria-hidden="false">
                        <p class="blind dv-pc-only">Overview</p>
                        <!-- DESCRIPTION -->
                        <div class="view-section view-description">
                          <h4 class="tit-h4">Description</h4>
                          <div class="data-content borbline" role="text">
                            <p class="para" v-html="lineBreakCntt(item.detailExpln)"></p>
                          </div>
                        </div>
                        <!-- //DESCRIPTION -->
                        <div class="view-appstar">
                          <div class="view-appwrap">
                            <div class="view-appinfo">
                              <h4 class="tit-h4">App Info</h4>
                              <ul>
                                <li class="applist">
                                  <p class="appinfo-tit">Age</p>
                                  <p class="appinfo-txt">{{ item.appAge }}</p>
                                </li>
                                <li class="applist">
                                  <p class="appinfo-tit">Version</p>
                                  <p class="appinfo-txt">{{ item.appVer }}</p>
                                </li>
                                <li class="applist">
                                  <p class="appinfo-tit">Updated</p>
                                  <p class="appinfo-txt">{{ item.updateDate }}</p>
                                </li>
                                <li class="applist">
                                  <p class="appinfo-tit">Size</p>
                                  <p class="appinfo-txt" v-html="fileSizeLineReplace(item.appFileSize)"></p>
                                </li>
                                <li class="applist">
                                  <p class="appinfo-tit">Language</p>
                                  <p class="appinfo-txt">{{ appSuptLangName }}</p>
                                </li>
                                <li class="applist">
                                  <p class="appinfo-tit">Category</p>
                                  <p class="appinfo-txt">{{ item.cat }}</p>
                                </li>
                                <li class="applist">
                                  <p class="appinfo-tit">Seller</p>
                                  <p class="appinfo-txt">{{ item.sellrUsrName }}</p>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- //탭내용1 -->
                    </div>
                  </div>
                </div>
                <!-- //상세정보 -->
              </div>
              <!-- //앱상세 전체영역 -->
            </div>
          </section>
          <!-- //상세섹션 -->
          <!-- 미등록게시물 -->
          <div class="noData-wrap" v-if="prodInfo.length == 0">
            <div class="noData">
              <div class="inner">
                <p><i class="ico ico-waring2"></i><span class="noData-txt">No Application Contents</span></p>
              </div>
            </div>
          </div>
          <!-- //미등록게시물 -->
        </div>
      </div>
      <!-- //탭메뉴 -->
      <!-- ScreenShot Zommer -->
      <div class="zommer-wrap" onclick="zommer.close(this)">
        <span class="zommer-body">
          <img src="" class="zommer-img" alt="">
          <a href="javascript:;" class="btn-ico btn-close" onclick="zommer.close(this);"><i class="ico ico-close-zommer">{{ $t('gwa.alt.common.wa_label_26') }}</i></a>
        </span>
      </div>
      <!-- //ScreenShot Zommer -->
    </div>
    <!-- //Content Body -->
  </section>
  <!-- //Content -->
</template>

<script>
import qs from "qs";

export default {
  name: "AllAppsDetail",
  data() {
    return {
      appId: "",
      prodInfo: [],
      appSuptLangName: "",
      screenShotList: [],
      featureList: [],
      loadingYn: "Y",
      cntryCode: _domainCntryCode
    }
  },
  methods: {
    track () {
      console.log('@@@@ track:', this.$router.currentRoute.path);
      this.$ga.page(this.$router.currentRoute.path)
    },
    setProdInfoResult(result) {
      const vm = this;

      vm.prodInfo = result.data.prodInfo;
      vm.appSuptLangName = result.data.appSuptLangName;
      vm.screenShotList = result.data.screenShotList;
      vm.featureList = result.data.featureList;
      vm.loadingYn = "N";

      if($("meta[name='appstore:store_id']").attr("content") == "") {
        $("meta[name='appstore:developer_url']").attr("content", result.data.devUrl);
        $("meta[name='appstore:bundle_id']").attr("content", result.data.bundleId);
        $("meta[name='appstore:store_id']").attr("content", result.data.storeId);
      }

      vm.$nextTick(function() {
        ui.init();
        loadSelected();
      });
    },
    fileSizeReplace(size) {
      if(this.cntryCode == "DE") {
        return size.replace(".", ",");
      } else {
        return size;
      }
    },
    fileSizeLineReplace(size) {
      return this.fileSizeReplace(size.replace("<br>", " "));
    },
    lineBreakCntt(cntt) {
      if(cntt != null && cntt != "") {
        return cntt.split("\n").join("<br />");
      } else {
        return "";
      }
    },
    getFeatIconText(icoType) {
      if(icoType == "1") {
        return "Internet";
      } else if(icoType == "2") {
        return "3D";
      } else if(icoType == "3") {
        return "Cam";
      } else if(icoType == "4") {
        return "Magic R";
      } else if(icoType == "5") {
        return "Gamepad";
      } else {
        return "";
      }
    }
  },
  mounted() {
    const vm = this;
    ui.loading.open();

    vm.appId = vm.$route.query.appId;

    const params = {
      appId: vm.appId
    };

    this.$axios.post("/api/tvapp/retrieveGlobalAppInfo.ajax",
        qs.stringify(params)).then((result) => {
      ui.loading.close();

      if(result.data.prodInfo != null) {
        vm.setProdInfoResult(result);
      } else {
        vm.loadingYn = "N";
        vm.$nextTick(function() {
          ui.init();
        });
      }
    }).catch((err) => {
      vm.$nextTick(function() {
        ui.loading.close();
        vm.loadingYn = "N";
      });
      alert("error : " + err);
    });
  }
}
</script>

<style scoped>
</style>